import { render, staticRenderFns } from "./threeAuth.vue?vue&type=template&id=c9a89c6c&scoped=true&"
import script from "./threeAuth.vue?vue&type=script&lang=js&"
export * from "./threeAuth.vue?vue&type=script&lang=js&"
import style0 from "./threeAuth.vue?vue&type=style&index=0&id=c9a89c6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a89c6c",
  null
  
)

export default component.exports